import { useEffect, useState } from "react";
import {
    useHistory,
    useLocation,
} from "react-router-dom";
import { firestore, storage } from "./firebase";
import Sidebar from "./Sidebar";
import UpdateEvent from "./UpdateEvent";


export default function LinkStickerOverview() {
    const [events, setEvents] = useState([]);
    useEffect(() => {
        let query = firestore.collection('events');
        query = query.where('story_link', '!=', null);
        query.onSnapshot(snapshot => {
            let docs = snapshot.docs;
            docs = docs.filter(doc => doc.data().start?.toDate().getTime() > Date.now());
            docs.sort((a, b) => {
                const aTimestamp = a.data().created_timestamp?._seconds ?? a.data().created_timestamp?.seconds ?? 0;
                const bTimestamp = b.data().created_timestamp?._seconds ?? b.data().created_timestamp?.seconds ?? 0;
                return bTimestamp - aTimestamp; // Sort descending
            });
            setEvents(docs);
        });
    }, []);

    return <div className="h-full flex w-auto">
        <Sidebar defaultOpen={false} />
        <div className="flex-grow overflow-auto">
            <div className="h-screen flex flex-col overflow-hidden">
                <div className="bg-gray-600 flex items-center text-white gap-2 p-3 justify-between">
                    <div className="text-l font-semibold">Events mit gebuchtem Link-Sticker</div>
                </div>
                <div className="p-3 overflow-y-scroll">
                    <div>
                        {events.map(event => <UpdateEvent key={event.id} object={event} />)}
                    </div>
                    {events.length === 0 && <div>
                        Es wurden keine Events in der Zukunft gefunden, die einen Link-Sticker gebucht haben.
                    </div>}
                </div>
            </div>
        </div>
    </div>;
}